import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';

export const Wrap = ({children}) => {
    return (
        <div css={css`
            max-width: 760px;
            margin: 0 auto;
            padding: 0 20px 45px;
        `}>
            {children}
        </div>
    )
}

export const Float = ({children}) => {
    return (
        <div css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            margin: auto;
            padding: 0 20px;
            height: 100%;
            height: -webkit-fill-available;

            @media (max-height: 479px) {
              overflow: auto;
              justify-content: flex-start;
              padding: 20px;
            }
        `}>
            {children}
        </div>
    )
};
export const FloatBack = ({children}) => {
    return (
        <div css={css`
            position: fixed;
            width: 100vw;
            height: 100vh;
            height: -webkit-fill-available;
            background-color: rgba(0,0,0,0.4);
            left: 0;
            top: 0;
            z-index: 5;
        `}>
            {children}
        </div>
    )
};


export const Title = ({name, children}) => {
    return (
        <h1 css={css`text-align: center;`}>{name || children}</h1>
    );
}
